import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../stateManagement/hooks/redux"
import { Button } from "primereact/button";
import NoRegionsMessage from "./NoRegionsMessage";

export default function RegionsInfo() {

    const navigate = useNavigate();
    const regionFeatures = useAppSelector(state => state.objectsOnMapPointInfo.regionFeatures)

    return (
        <div className="regions-info-div">
            <strong>Регионы:</strong>
            <div>
                {regionFeatures.map((feature: any) => {
                    const [, id] = feature.id.split('.')
                    return (
                        <Button severity="info" text raised onClick={() => navigate(`/app/osmRegion/${id}`)}>
                            {feature.properties.NAME}
                        </Button>
                    )
                })}
                {regionFeatures.length === 0 && <NoRegionsMessage />}
            </div>
        </div>
    )
}
